import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function AgeGate({ children }) {
  const [verified, setVerified] = useState(false);
  const [denied, setDenied] = useState(false);
  const { t, language, toggleLanguage } = useLanguage();

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (ageVerified === 'true') {
      setVerified(true);
    }
  }, []);

  const handleYes = () => {
    localStorage.setItem('ageVerified', 'true');
    setVerified(true);
  };

  const handleNo = () => {
    setDenied(true);
  };

  if (verified) {
    return children;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0A0A0A]">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
      </div>
      
      <div className="absolute top-6 right-6">
        <button
          onClick={toggleLanguage}
          className="text-xs tracking-[0.2em] text-white/50 hover:text-gold transition-colors uppercase"
          data-testid="age-gate-language-toggle"
        >
          {language === 'sr' ? 'English' : 'Srpski'}
        </button>
      </div>
      
      <div className="relative max-w-lg w-full mx-6 text-center animate-fade-in">
        {/* Logo/Brand */}
        <div className="mb-12">
          <div className="decorative-line mx-auto mb-8" />
          <p className="text-gold text-xs tracking-[0.4em] uppercase mb-4">Est. 2021</p>
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white mb-3">
            Destilerija
          </h1>
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl gold-gradient mb-6">
            Kovačić
          </h1>
          <div className="decorative-line mx-auto" />
        </div>

        <div className="glass p-10">
          {denied ? (
            <div data-testid="age-gate-denied">
              <p className="text-white/80 text-lg mb-8 font-light">{t('age_notice')}</p>
              <button
                onClick={() => setDenied(false)}
                className="text-gold hover:text-gold-light transition-colors text-sm tracking-wider uppercase"
                data-testid="age-gate-try-again"
              >
                ← {t('back')}
              </button>
            </div>
          ) : (
            <>
              <p className="text-white/90 text-xl mb-10 font-heading" data-testid="age-gate-question">
                {t('age_question')}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={handleYes}
                  className="bg-gold hover:bg-gold-light text-black px-10 py-4 text-sm tracking-[0.15em] uppercase font-medium transition-all duration-300"
                  data-testid="age-gate-yes"
                >
                  {t('age_yes')}
                </button>
                <button
                  onClick={handleNo}
                  className="border border-white/20 text-white/80 hover:border-gold/50 hover:text-white px-10 py-4 text-sm tracking-[0.15em] uppercase transition-all duration-300"
                  data-testid="age-gate-no"
                >
                  {t('age_no')}
                </button>
              </div>
            </>
          )}
        </div>

        <p className="mt-10 text-white/30 text-xs tracking-wider">
          {t('footer_age_notice')}
        </p>
      </div>
    </div>
  );
}
